module.exports = __webpack_public_path__ + "static/media/jyrki.varvas.4b5c8f1e.jpg";